import { headerSticky } from './_headerSticky.js';
import { initializeSwiper } from './_swiper.js';
import { stickyBuyTicket } from './_stickyBuyTicket.js';
import { initGLightBox } from './_glightbox.js';
import { initFilterOptions } from './_filter-options.js';
import { initSkipHero } from './_skip-hero.js';
import initGalleryMasonry from './_galleryMasonry.js';
import { ScrollSpy } from './_scrollSpy.js';
import initModal from './_modal.js';
import { initAccordions } from './_accordions.js';
import { initFilterMultiOptions } from './_filter-multi-options.js';
import initSideNavigationMobile from './_sideNavigationMobile.js';
import initTabs from './_tabs.js';

document.addEventListener('DOMContentLoaded', () => {
  headerSticky();
  initializeSwiper();
  stickyBuyTicket();
  initGLightBox();
  initFilterOptions();
  initSkipHero();
  initGalleryMasonry();
  initModal();
  initAccordions();
  initFilterMultiOptions();
  initSideNavigationMobile();
  initTabs();
});
